import { SET_BILLING_USAGE, CLEAR_BILLING_USAGE, SET_LAST_MONTH_BILLING_USAGE } from './billingUsageTypes';

export const setBillingUsage = (usage) => ({
    type: SET_BILLING_USAGE,
    payload: usage,
});

export const setLastMonthBillingUsage = (usage) => ({
    type: SET_LAST_MONTH_BILLING_USAGE,
    payload: usage,
});

export const clearBillingUsage = () => ({
    type: CLEAR_BILLING_USAGE,
});
